import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { Modal, Button } from 'react-bootstrap';
import { RootState } from '../store/reducers/reducers';
import { actions } from '../store/actions';
import styles from '../styles/region_switch_modal.module.scss';
import {setPromptDismissed, useRegionCountryCode} from '../hooks/region';
import FlagIcon from './flag_icon';
import countriesAndStates from "../constants/address_fields";


export default function RegionSwitchModal () {
  const dispatch = useDispatch();
  const router = useRouter();
  const { countryCode: currentRegion } = useRegionCountryCode();

  const { showRegionSwitchModal, detectedRegion } = useSelector((state: RootState) => state.region);

  const handleSwitch = () => {
    if (!detectedRegion || !currentRegion) return;

    const newRegion = detectedRegion;
    const oldRegion = currentRegion;

    const newPath = router.asPath.startsWith(`/${oldRegion}`)
      ? router.asPath.replace(`/${oldRegion}`, `/${newRegion}`)
      : router.asPath;

    const finalPath = newPath.startsWith('//') ? newPath.substring(1) : newPath;

    router.push(finalPath);
    setPromptDismissed();
    dispatch(actions.region.hideRegionSwitchModal());
  };

  const handleStay = React.useCallback(() => {
    setPromptDismissed();
    dispatch(actions.region.hideRegionSwitchModal());
  }, [dispatch]);

  if (!showRegionSwitchModal || !detectedRegion) {
    return null;
  }
  
  const countryName = countriesAndStates.countries[detectedRegion]?.displayValue ?? detectedRegion;

  return (
    <Modal show={showRegionSwitchModal} onHide={handleStay} centered>
      <Modal.Header closeButton>
        <Modal.Title className={styles.title}>Location Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.message}>
        We've detected you are in <strong>{countryName}</strong>. Would you like to switch region for a better shopping experience?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleStay} className={styles.button}>
          <FlagIcon countryCode={currentRegion} size={20} />
          Stay on {currentRegion}
        </Button>
        <Button variant="primary" onClick={handleSwitch} className={styles.button}>
          <FlagIcon countryCode={detectedRegion} size={20} />
          Switch to {detectedRegion}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
